import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_65: FaireProductEntity = {
  token: "legacy_prod_abbott-65",
  type: "product",
  name: "Gothica Lined Notebook 6×8 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0315beb9302a55f0e12cce595a334071e87862a44528c233f198c67b7eb78f7f.jpeg",
  priceDollars: 9,
  msrpDollars: 14,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
